import i18n from 'locales/i18n';
import { NavLink } from 'react-router-dom';
import { ROUTES } from 'routes/constants';
import dashboard_icon from './../../assets/icons/dashboard .svg'
import Eventm from './../../assets/icons/event.svg'
import transaction from './../../assets/icons/transaction.svg'
import { ItemWithEnforcedKey } from './menu-items.types';
import { sideBarpermission } from './side-bar-permission';
import { HasPermission } from 'utils/CheckPermissions';

export const getMenuItems = (



): ItemWithEnforcedKey[] => [
    HasPermission(sideBarpermission.dashboard, "view") ?
      {
        key: ROUTES.DASHBOARD,
        icon: <img src={dashboard_icon} alt="" />,
        label: 'Dashboard',
        children: [
          HasPermission(sideBarpermission.registration, "view") ?

            {
              key: ROUTES.EXECUTIVE_SUMMARY,
              label: (
                <NavLink to={ROUTES.EXECUTIVE_SUMMARY}>
                  Executive Summary
                </NavLink>
              ),
            } : null,
          HasPermission(sideBarpermission.registration, "view") ?
            {
              key: ROUTES.REGISTRATION_CROSS_SALES,
              label: <NavLink to={ROUTES.REGISTRATION_CROSS_SALES}>
                Registration
              </NavLink>,
            } : null,
          HasPermission(sideBarpermission.shop, "view") ?
            {
              key: ROUTES.SHOP_CROSS,
              label: (
                <NavLink to={ROUTES.SHOP_CROSS}>
                  Shop
                </NavLink>
              ),
            } : null,
          HasPermission(sideBarpermission.booth, "view") ?
            {
              key: ROUTES.BOOTH,
              label: <NavLink to={ROUTES.BOOTH}>
                Booth
              </NavLink>,
            } : null as any,
        ],
      } : null
    ,
    HasPermission(sideBarpermission.event_management, "view") ?
      {
        key: ROUTES.EVENTS_ALL,
        label: i18n.t('sideBar.menu.eventManagement.all'),
        icon: <img src={Eventm} alt="" />,
        children: [
          HasPermission(sideBarpermission.event_list, "view") ?

            {
              key: ROUTES.EVENTS,
              label: (
                <NavLink to={ROUTES.EVENTS}>
                  {i18n.t('sideBar.menu.eventManagement.eventList')}
                </NavLink>
              ),
            } : null,
        ],
      } : null
    ,
    HasPermission(sideBarpermission.transactions, "view") ?

      {
        key: ROUTES.TRANSACTION,
        label: "Transactions",
        icon: <img src={transaction} alt="" />,

        children: [
          HasPermission(sideBarpermission.invoice_list, "view") ?

            {
              key: ROUTES.TRANSACTION_INVOICE_LIST,
              label: (
                <NavLink to={ROUTES.TRANSACTION_INVOICE_LIST}>
                  Invoice List
                </NavLink>
              ),
            } : null,
          HasPermission(sideBarpermission.participant_list, "view") ?

            {
              key: ROUTES.TRANSACTION__PARTICIPATE_LIST,
              label: (
                <NavLink to={ROUTES.TRANSACTION__PARTICIPATE_LIST}>
                  Participant list
                </NavLink>
              ),
            } : null,
          HasPermission(sideBarpermission.group_registration, "view") ?

            {
              key: ROUTES.TRANSACTION__GROUP_REGISTRATION_LIST,
              label: (
                <NavLink to={ROUTES.TRANSACTION__GROUP_REGISTRATION_LIST}>
                  Group Registration
                </NavLink>
              ),
            } : null,
          // : null,

          HasPermission(sideBarpermission.reports, "view") ?
          {
            key: ROUTES.TRANSACTION__REPORTS,
            label: (
              <NavLink to={ROUTES.TRANSACTION__REPORTS}>
                Reports
              </NavLink>
            ),
          }:null,
        ],
      } : null
    ,

  ];
